// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'

import Vue from 'vue'
import App from './App'

//Vuex
import Vuex from 'vuex'
import store from './store/index'
Vue.use(Vuex)

//
import VueResource from 'vue-resource'
Vue.use(VueResource)

//路由权限
import router from './router'

/*import {
	asyncRouterMap,
	constantRouterMap
} from './router'
*/

//axios
import axios from 'axios'
import { axiosget, axiospost, axiosdelete, axiosput, dataUrl } from '@/utils/axiosMethods'

// 修改原型使axios可以在其他组件使用
Vue.prototype.$axios = axios
Vue.prototype.$axiosget = axiosget
Vue.prototype.$axiospost = axiospost
Vue.prototype.$axiosdelete = axiosdelete
Vue.prototype.$axiosput = axiosput
Vue.prototype.dataUrl = dataUrl

//ElementUI
import ElementUI from 'element-ui'
import { Loading, Message, Notification } from 'element-ui'
Vue.use(ElementUI)

import VueKonva from 'vue-konva'
Vue.use(VueKonva)

import VueAMap from 'vue-amap'

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'f20cfaf9c55ee2a951edf347a510ab7a',
  plugin: [
    'Map3D',
    'AMap.PlaceSearch',
    'AMap.Autocomplete',
    'AMap.DistrictSearch',
    'AMap.MarkerClusterer',
    'AMap.InfoWindow'
  ],
  v: '1.4.15'
})

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.prototype.hasPermissions = function(permission) {
  let myPermissions = this.$store.getters.permissions
  //console.log(permission, myPermissions)
  return myPermissions.indexOf(permission) > -1
}

//存放请求的数组
Vue.Cancel = []

// Echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import VueHtml5Editor from 'vue-html5-editor'
import options from './components/dynamicRoute3/management/studyonline/config/option.js'
import './assets/font-awesome-4.7.0/font-awesome-4.7.0/css/font-awesome.min.css'
Vue.use(VueHtml5Editor, options)

Vue.config.productionTip = false

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

//下载EXCEL
const downloadPost = config => {
  const url = config.url
  // const data = decodeURI(config.data).split("&") //JSON.parse(config.data)// JSON.parse(config.data)
  const form = document.createElement('form')
  form.action = url
  form.method = 'post'
  form.style.display = 'none'
  // Object.keys(data).forEach(key => {
  //     const input = document.createElement('input')
  //     input.name = key
  //     input.value = data[key]
  //     form.appendChild(input)
  // })
  // data.forEach(function (item, index) {
  // 	const input = document.createElement('input')
  // 	var q = item.replace(/\%3A/g, ":")
  // 	q = q.replace(/\%2B/g, "+")
  // 	q = q.replace(/\%2F/g, "/")
  // 	q = q.replace(/\%3D/g, "=")
  // 	q = q.split("=")
  // 	input.name = q[0]
  // 	input.value = q[1]
  // 	form.appendChild(input)
  // });
  const button = document.createElement('input')
  button.type = 'submit'
  form.appendChild(button)
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
  let loading = Loading.service({})
  loading.close()
}

// http request 拦截器

axios.interceptors.request.use(
  config => {
    // 添加请求拦截器
    // config.cancelToken = new axios.CancelToken(cancel => {
    // 	Vue.cancel.push({
    // 	  url: config.url,
    // 	  cancel
    // 	})
    //   })
    if (localStorage.getItem('token')) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.common['authorization'] = localStorage.getItem('token')
    }
    if (localStorage.getItem('companyId')) {
      // 判断是否存在companyId，如果存在的话，则每个http header都加上companyId
      config.headers.common['companyId'] = localStorage.getItem('companyId')
    }
    if (localStorage.getItem('user')) {
      // 判断是否存在companyId，如果存在的话，则每个http header都加上companyId
      config.headers.common['userId'] = JSON.parse(localStorage.getItem('user')).id
    }
    if (localStorage.getItem('loginSuper')) {
      config.headers.common['userId'] = JSON.parse(localStorage.getItem('loginSuper')).data.user.id
    }
    if (localStorage.getItem('userAccount')) {
      // 判断是否存在companyId，如果存在的话，则每个http header都加上companyId
      config.headers.common['userAccount'] = JSON.parse(localStorage.getItem('userAccount'))
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器

axios.interceptors.response.use(
  response => {
    // 处理excel文件
    if (response.headers && response.headers['content-type'] === 'application/x-msdownload') {
      const config = response.config
      if (config.method === 'post') {
        downloadPost(config)
      }
      return
    }
    return response
  },
  error => {
    if (error.response) {
      Notification.closeAll()
      switch (error.response.status) {
        case 401:
          localStorage.clear()
          Notification({
            title: '提示',
            message: '登录已过期，请重新登录！',
            type: 'warning',
            duration: 1500
          })
          router
            .replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
            .then(r => {})
          break
        case 403:
          Notification({
            title: '提示',
            message: '没有权限，请向管理员申请权限！',
            type: 'error',
            duration: 3000
          })
          break
        case 500:
          Notification({
            title: '提示',
            message: '系统错误，请稍后再试！',
            type: 'error',
            duration: 3000
          })
          break
      }
    }
    if (
      !error.response.status ||
      !(
        error.response.status === 500 ||
        error.response.status === 401 ||
        error.response.status === 403
      )
    ) {
      return Promise.reject(error)
    }
  }
)

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth || to.name === null) {
    //存在token
    if (localStorage.getItem('token')) {
      document.title = JSON.parse(localStorage.getItem('user')).title
        ? JSON.parse(localStorage.getItem('user')).title
        : '消防平台'
      //不存在权限列表
      if (store.state.menu.length == 0) {
        store.dispatch('addRoutes').then(() => {
          //确实没有权限
          if (store.state.menu.length == 0) {
            next({
              path: '/login'
            })
            Notification({
              title: '提示',
              message: '该用户暂无权限登录系统！',
              type: 'error',
              duration: 3000
            })
          } else {
            next({ path: to.path != '/' ? to.path : '/home', query: to.query })
          }
        })
      }
      //存在权限列表
      else {
        next()
      }
    }
    //没有token
    else {
      next({
        path: '/login'
      })
    }
  }
  //不需要权限的页面
  else {
    next()
  }

  Vue.Cancel = []
})

export default axios

import elNumberInput from 'public/element-secondary/el-number-input'
Vue.component('el-number-input', elNumberInput)

import elUploadSecondary from 'public/element-secondary/el-upload-secondary'
// import elUploadSecondary from "PublicVueComponent/components/element-secondary/el-upload-secondary"
Vue.component('el-upload-secondary', elUploadSecondary)

import elRow from 'public/element-secondary/r/src/row'
Vue.component('row', elRow)

import elCol from 'public/element-secondary/c/src/col'
import vueHtml5Editor from 'vue-html5-editor'
Vue.component('cell', elCol)

// 自定义指令 图片加载失败时，加载默认图片
Vue.directive('defaultImg', async function(el, binding) {
  // let defaultImgUrl = binding.value || '默认图片地址'
  let imgUrl = el.getAttribute('src')
  let fileUrl = process.env.fileUrl
  if (imgUrl && imgUrl.includes(fileUrl)) {
    if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
      imgUrl = imgUrl.replaceAll(fileUrl, process.env.SSL_HOST + '/file/')
    }
  }
  // TODO 校验图片 否则展示默认图片
  el.setAttribute('src', imgUrl)
})

let imgUrlValid = function(url) {
  return new Promise(resolve => {
    let img = new Image()
    img.onload = function() {
      if (this.complete) {
        img = null
        resolve(true)
      }
    }
    img.onerror = function() {
      img = null
      resolve(false)
    }
    img.src = url
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  //echarts,
  store,
  template: '<App/>',
  components: {
    App
  },
  data() {
    return {
      areaALL: null
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js